import {inlineError} from '@s-ui/decorators/lib/index.js'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetLoanCalculationsB2CTransactionsService extends Service {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute(loanCalculationsB2CParams) {
    const [error, response] = await this._httpTransactionsRepository.getLoanCalculationsB2C(loanCalculationsB2CParams)
    if (error) return Promise.reject(error)
    return response
  }
}
